/**@typedef {[string]: (eventData: any) => any } EventCallback */

/**@type {[string]: EventCallback[] } */
var CALLBACKS = {};
/**@param {any} data Serializable data */

var sendMessage = function sendMessage(iframe, data) {
  var crtWindow = iframe.contentWindow;
  crtWindow.postMessage(data, '*');
};

window.onmessage = function (e) {
  var msg = e.data;
  runCallbacks(msg.event, msg.data);
};

var runCallbacks = function runCallbacks(eventName, eventData) {
  eventName = eventName || '';
  var callbacksKeys = Object.keys(CALLBACKS);
  var callbacksKey = callbacksKeys.find(function (key) {
    return eventName.startsWith(key);
  });
  if (!callbacksKey || !CALLBACKS[callbacksKey]) return;
  CALLBACKS[callbacksKey].map(function (callback) {
    callback(eventName, eventData);
  });
};
/**
 * @param {string} eventName
 * @param {any} eventData Serializable data
 * */


var send = function send(iframe, eventName, eventData) {
  var data = {
    event: eventName,
    data: eventData
  };
  return sendMessage(iframe, data);
};
/**
 * @param {string} eventName
 * @param {EventCallback} eventCallback
 * */


var on = function on(eventName, eventCallback) {
  CALLBACKS[eventName] = CALLBACKS[eventName] || [];
  CALLBACKS[eventName].push(eventCallback);
};
/**
 * @param {string} eventName
 * @param {EventCallback} [eventCallback]
 * */


var off = function off(eventName, eventCallback) {
  CALLBACKS[eventName] = CALLBACKS[eventName] || [];

  if (eventCallback) {
    var idx = CALLBACKS[eventName].indexOf(eventCallback);
    CALLBACKS[eventName].splice(idx, 1);
  } else {
    CALLBACKS[eventName] = [];
  }
};

export default {
  send: send,
  on: on,
  off: off
};